import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../../../../common/state/store";

export interface ModalState {
  showStandardModal: { show: boolean; id: string };
  showFormModal: boolean;
  showPopupModal: boolean;
  showConfirmationModal: { show: boolean; id: string };
  showMediaPreviewModal: { show: boolean; id: string };
}

const initialState: ModalState = {
  showStandardModal: { show: false, id: "" },
  showFormModal: false,
  showPopupModal: false,
  showConfirmationModal: { show: false, id: "" },
  showMediaPreviewModal: { show: false, id: "" },
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openFormModal: (state: ModalState) => {
      state.showFormModal = true;
    },
    closeFormModal: (state: ModalState) => {
      state.showFormModal = false;
    },
    openPopupModal: (state: ModalState) => {
      state.showPopupModal = true;
    },
    closePopupModal: (state: ModalState) => {
      state.showPopupModal = false;
    },
    openStandardModal: (state: ModalState, actions: PayloadAction<string>) => {
      state.showStandardModal = {
        show: true,
        id: actions.payload,
      };
    },
    closeStandardModal: (state: ModalState, actions: PayloadAction<string>) => {
      state.showStandardModal = {
        show: false,
        id: actions.payload,
      };
    },
    openConfirmationModal: (state: ModalState, actions: PayloadAction<string>) => {
      state.showConfirmationModal = {
        show: true,
        id: actions.payload,
      };
    },
    closeConfirmationModal: (state: ModalState, actions: PayloadAction<string>) => {
      state.showConfirmationModal = {
        show: false,
        id: actions.payload,
      };
    },
    openMediaPreviewModal: (state: ModalState, actions: PayloadAction<string>) => {
      state.showMediaPreviewModal = {
        show: true,
        id: actions.payload,
      };
    },
    closeMediaPreviewModal: (state: ModalState, actions: PayloadAction<string>) => {
      state.showMediaPreviewModal = {
        show: false,
        id: actions.payload,
      };
    },
  },
});
export const getShowStandardModal = (state: RootState) => state.modals.showStandardModal;
export const getShowMediaPreviewModal = (state: RootState) => state.modals.showMediaPreviewModal;
export const getCurrentModalCurrentState = (state: RootState) => state.modals;
export const getConfirmationModalStateShow = (state: RootState) =>
  state.modals.showConfirmationModal.show;

export const {
  closePopupModal,
  openStandardModal,
  openMediaPreviewModal,
  closeMediaPreviewModal,
  closeStandardModal,
  openConfirmationModal,
  closeConfirmationModal,
} = modalSlice.actions;

export default modalSlice.reducer;
